import React, { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../../../components/AdminPanel/SideBar";
import CareerOption from "../../../components/AdminPanel/CareerOption/CareerOption";
import Modal from "../../../components/AdminPanel/CareerOption/Modal";
import PostModal from "../../../components/AdminPanel/CareerOption/PostModal";

function AdminCareerOption() {
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [showPostModal, setShowPostModal] = useState(false);

    const [filterData, setFilterData] = useState([]);
    async function fetchData() {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/careerPost`); // Hardcoded URL
            setData(response.data);
            setFilterData(response.data);
        } catch (error) {
            console.error("Error:", error);
        }
    }


    const onClose = () => {
        setModal(false);
        fetchData();
    };


    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/careerPost`); // Hardcoded URL
                setData(response.data);
                setFilterData(response.data);
            } catch (error) {
                console.error("Error:", error);
            }
        }
        fetchData();
    }, []);

    function handleChange(e) {
        const searchValue = e.target.value.toLowerCase();
        setFilterData(
            data.filter((d) => d.job.toLowerCase().includes(searchValue)) // Search by job title
        );
    }

    return (
        <div className="flex">
            <SideBar />
            <div className="flex flex-col md:mt-12 md:ml-[16%] font-sans w-full">
                <div className="flex items-center justify-between my-6 px-4">
                    <div className="text-left font-medium text-gray-500 py-2 text-lg">Career Postings</div>
                    <input
                        name="search"
                        type="text"
                        placeholder="Search by Job Title"
                        onChange={handleChange}
                        className="border px-3 py-1 rounded-xl w-[250px] flex-[0.75]" 
                    />
                    <button onClick={() => setShowPostModal(true)}  className="bg-[#173d73] text-white px-6 py-2 rounded-xl duration-300 hover:bg-blue-700 whitespace-nowrap">Add New</button>

                </div>
                <CareerOption filterData={filterData} />
                <Modal isOpen={modal} onClose={onClose} />

                <PostModal isOpen={showPostModal} onClose={() => { setShowPostModal(false); fetchData(); }} />

            </div>
        </div>
    );
}

export default AdminCareerOption;
